import { AnimatePresence } from "framer-motion";
import { Routes, Route, useLocation } from "react-router-dom";

import * as ROUTES from "../constants/routes";
import Login from "../pages/Login";
import AboutUs from "../pages/AboutUs";
import MorseBridge from "../pages/MorseBridge";
import CertifiiPage from "../pages/CertifiiPage";
import VaultinumPage from "../pages/VaultinumPage";
import WebinarLanding from "../pages/WebinarLanding";
import Register from "../pages/Register";
import ContactUs from "../pages/ContactUs";
import PartnerProgram from "../pages/PartnerProgram";
import LandingHomePartner from "../pages/landingPage/homePage/Partner";
import LandingHomeCommunity from "../pages/landingPage/homePage/Community";
import { Privacy, CookiePolicy, DataEthics, AllUse, DMCA } from "../pages/newPolicies";
import { AcceptableUse, CompanyTerms, IndividualsTerms } from "../pages/termsAndCondition";

import HomePage from "../pages/landingPage/homePage/HomePage";
import ExitReadyCompanies from "../pages/ExitReadyCompanies";
import GrowthReadyCompanies from "../pages/GrowthReadyCompanies";
import InvestmentReadyCompanies from "../pages/InvestmentReadyCompanies";

import Lawyers from "../pages/Lawyers";
import Accountants from "../pages/Accountants";

import AngelNetworks from "../pages/AngelNetworks";
import AngelInvestors from "../pages/AngelInvestors";
import PrivateEquityFirms from "../pages/PrivateEquityFirms";
import VentureCapitalFirms from "../pages/VentureCapitalFirms";

import Terms from "../pages/Terms";
import Policies from "../pages/Policies";
import NotFound from "../pages/NotFound";

import Group from "../pages/logged_in/Group";
import Billing from "../pages/logged_in/Billing";
import BillingDetail from "../pages/logged_in/BillingDetail";
import Support from "../pages/logged_in/Support";
import Profile from "../pages/logged_in/Profile";
import ESGPack from "../pages/logged_in/ESGPack";
import Admin from "../pages/logged_in/Admin/index";
// import AdminCompanyDetails from "../pages/logged_in/Admin/AdminCompanyDetails";
import Dashboard from "../pages/logged_in/Dashboard";
import Company from "../pages/logged_in/Company/index";
import CompanyNew from "../pages/logged_in/Company/indexNew";
import Report from "../pages/logged_in/Company/ReportOld";
import Advisor from "../pages/logged_in/Advisor/index.js";
import IndustryPack from "../pages/logged_in/IndustryPack";
import ExpansionPack from "../pages/logged_in/ExpansionPack";
import DirectorsPack from "../pages/logged_in/DirectorsPack";
import CompanyWrapper from "../pages/logged_in/Company/CompanyWrapper";
import CompanySettings from "../pages/logged_in/Company/CompanySettings.js";
import Settings from "../pages/logged_in/Advisor/Settings/index.js";
import ExpansionReferencing from "../pages/logged_in/ExpansionReferencing";

import PricingPlans from "../pages/PricingPlans";
import LandingHomePEs from "../pages/landingPage/homePage/PEs";
import LandingHomeVcs from "../pages/landingPage/homePage/VCs";
import LandingHomeAngels from "../pages/landingPage/homePage/Angels";
import LandingHomePisces from "../pages/landingPage/homePage/Pisces";
import LandingHomeClimb26 from "../pages/landingPage/homePage/Climb26.js";
import LandingHomeCompanies from "../pages/landingPage/homePage/Companies";
import LandingHomeAccountant from "../pages/landingPage/homePage/Accountants";
import LandingHomeAngelNetworks from "../pages/landingPage/homePage/AngelsNetworks";
import LandingHomeFractional from "../pages/landingPage/homePage/Fractional";

import CreateChecklist from "../pages/checklist";
import DemoChecklist from "../pages/demo-checklist";
import PartnerChecklist from "../pages/partners-checklist";

import ResearchAid from "../pages/logged_in/Company/ResearchAid/ResearchAid.js";

import ManualAdd from "../pages/logged_in/ManualAdd.js";
import InvestorMatch from "../pages/super-flow/index.js";
import InvestorMatchStats from "../pages/logged_in/InvestorMatchStats.js";
import CompleteInvestment from "../pages/super-flow/CompleteInvestment.js";

import TestPage from "../pages/TestPage.js";
import Blogs from "../pages/blogs/index.jsx";
import BlogDetailPage from "../pages/blogs/BlogDetailPage/index.jsx";
import LandingHomeAccelerator from "../pages/landingPage/homePage/Accelerator.js";
import AeoArticlePage from "./landingPage/AeoArticles/AeoArticlePage.js";
import { AEO_ARTICLES } from "./landingPage/AeoArticles/aeoArticlesData.js";
// import useDetectIntercom from "../hooks/useDetectIntercom.js";
import { useEffect } from "react";
import PaymentSuccess from "../pages/payment/success/index.jsx";
import PaymentCancel from "../pages/payment/cancel/index.jsx";
import ForgotPassword from "../pages/ForgotPassword.jsx";
import DiligencePackExternal from "../pages/logged_in/DiligencePackExternal.js";

import InvestmentReadyJourney from "../pages/landingPage/company/InvestmentReadyJourney.js";
import GrowthReadyJourney from "../pages/landingPage/company/GrowthReadyJourney.js";
import ExitReadyJourney from "../pages/landingPage/company/ExitReadyJourney.js";
import ConfirmEmailChange from "../pages/confirmEmailChange.js";
import InnerPricingPage from "../pages/logged_in/InnerPricingPage.jsx";
import IndirectCompanyBillingPage from "../pages/logged_in/IndirectCompanyBillingPage.jsx";
import QuestionAnswersPage from "../pages/logged_in/Company/NewDashboard/QuestionAnswersPage/index.js";

export default function AnimatedRoutes() {
	const location = useLocation();

	// useEffect(() => {
	// 	const interval = setInterval(() => {
	// 		const element = document.querySelector(".intercom-lightweight-app-launcher");
	// 		if (element) {
	// 			element.style.right = "70px";
	// 			element.style.bottom = "16px";
	// 			clearInterval(interval); // Stop checking once the element is found
	// 		}
	// 	}, 2000); // Check every 500ms

	// 	return () => clearInterval(interval); // Cleanup on unmount
	// }, []);

	return (
		<AnimatePresence mode="wait">
			<Routes location={location} key={location.pathname}>
				<Route path={ROUTES.HOME} element={<HomePage />} />
				<Route path={ROUTES.LOGIN} element={<Login />} />
				<Route path={ROUTES.REGISTER} element={<Register />} />
				<Route path={ROUTES.HOME_PAGE} element={<HomePage />} />
				<Route path={ROUTES.TEST_PAGE} element={<TestPage />} />
				<Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPassword />} />
				<Route path={ROUTES.LANDING_PAGE} element={<LandingHomeCompanies />} />

				<Route path={ROUTES.COMPANY_INVESTMENT_READY} element={<InvestmentReadyJourney />} />
				<Route path={ROUTES.COMPANY_GROWTH_READY} element={<GrowthReadyJourney />} />
				<Route path={ROUTES.COMPANY_EXIT_READY} element={<ExitReadyJourney />} />

				<Route path={ROUTES.DEMOCHECKLIST} element={<DemoChecklist />} />
				<Route path={ROUTES.CREATECHECKLIST} element={<CreateChecklist />} />
				<Route path={ROUTES.PARTNERCHECKLIST} element={<PartnerChecklist />} />

				<Route path={ROUTES.RESEARCHAID} element={<ResearchAid />} />
				<Route path={ROUTES.MANUAL_ADD} element={<ManualAdd />} />
				<Route path={ROUTES.SUPERFLOW} element={<InvestorMatch />} />
				<Route path={ROUTES.COMPLETE_INVESTMENT} element={<CompleteInvestment />} />
				<Route path={ROUTES.INVESTOR_MATCH_STATS} element={<InvestorMatchStats />} />

				{/* BLOGS */}
				<Route path={ROUTES.BLOGS} element={<Blogs />} />
				<Route path={ROUTES.BLOG_DETAILS} element={<BlogDetailPage />} />

				{/* Landing page routes */}
				<Route path={ROUTES.LANDING_PAGE_COMPANIES} element={<LandingHomeCompanies />} />
				<Route path={ROUTES.LANDING_PAGE_ACCOUNTANT} element={<LandingHomeAccountant />} />
				<Route path={ROUTES.LANDING_PAGE_PISCES} element={<LandingHomePisces />} />
				<Route path={ROUTES.LANDING_PAGE_VCS} element={<LandingHomeVcs />} />
				<Route path={ROUTES.LANDING_PAGE_PES} element={<LandingHomePEs />} />
				<Route path={ROUTES.LANDING_PAGE_FRACTIONAL} element={<LandingHomeFractional />} />
				<Route path={ROUTES.LANDING_PAGE_ANGEL_NETWORKS} element={<LandingHomeAngelNetworks />} />
				<Route path={ROUTES.LANDING_PAGE_ANGELS} element={<LandingHomeAngels />} />
				<Route path={ROUTES.LANDING_PAGE_CLIMB} element={<LandingHomeClimb26 />} />
				<Route path={`${ROUTES.LANDING_PAGE_CLIMB}/:partnerId`} element={<LandingHomeClimb26 />} />
				<Route path={ROUTES.LANDING_PAGE_CLIMB26} element={<LandingHomeClimb26 />} />

				{/* AEO hub-and-spoke — clean ICP hub URLs (canonical) aliasing the landing pages */}
				<Route path='/cfo' element={<LandingHomeFractional />} />
				<Route path='/vc' element={<LandingHomeVcs />} />
				<Route path='/angel-network' element={<LandingHomeAngelNetworks />} />
				<Route path='/ceo' element={<LandingHomeCompanies />} />
				<Route path='/accelerator' element={<LandingHomeAccelerator />} />
				<Route path='/pisces' element={<LandingHomePisces />} />
				{/* AEO article pages — registered as STATIC paths so they outrank dynamic routes (e.g. /company/:id) */}
				{AEO_ARTICLES.map(a => (
					<Route key={`${a['icpSlug']}/${a['slug']}`} path={`/${a['icpSlug']}/${a['slug']}`} element={<AeoArticlePage icpSlug={a['icpSlug']} slugOverride={a['slug']} />} />
				))}

				<Route path='/reset_password/:hash' element={<Login />} />
				<Route path='/newMember/:hash' element={<LandingHomeCompanies />} />
				<Route path='/verifyEmail/:hash' element={<LandingHomeCompanies />} />
				<Route path='/verifyAdvisor/:hash' element={<LandingHomeCompanies />} />
				<Route path='/investorToken/:hash' element={<LandingHomeCompanies />} />
				<Route path='/newAdvisorCompany/:hash' element={<LandingHomeCompanies />} />
				<Route path='/newInvestorCompany/:hash' element={<LandingHomeCompanies />} />
				<Route path='/hashToken/:hash/company/:hash' element={<LandingHomeCompanies />} />
				<Route path='/hashToken/:hash/diligence-pack/:id' element={<DiligencePackExternal />} />
				<Route path='/shareCode/:code/diligence-pack/:id' element={<DiligencePackExternal />} />
				<Route path={ROUTES.EXTERNAL_DILIGENCE_PACK} element={<DiligencePackExternal />} />
				<Route path={ROUTES.ADVISOR_TOKEN} element={<LandingHomeCompanies />} />

				<Route path={ROUTES.ABOUT} element={<AboutUs />} />
				{/* Co-branded partner page — opened in a new tab from the dashboard Financial / Technology tabs. */}
				<Route path={ROUTES.MORSEBRIDGE} element={<MorseBridge />} />

				{/* Diligentsia x Certifii — Financial tab, one page per persona */}
				<Route path={ROUTES.CERTIFII_COMPANY} element={<CertifiiPage persona="company" />} />
				<Route path={ROUTES.CERTIFII_ADVISOR} element={<CertifiiPage persona="advisor" />} />
				<Route path={ROUTES.CERTIFII_INVESTOR} element={<CertifiiPage persona="investor" />} />

				{/* Diligentsia x Vaultinum — Technology tab, one page per persona */}
				<Route path={ROUTES.VAULTINUM_COMPANY} element={<VaultinumPage persona="company" />} />
				<Route path={ROUTES.VAULTINUM_ADVISOR} element={<VaultinumPage persona="advisor" />} />
				<Route path={ROUTES.VAULTINUM_INVESTOR} element={<VaultinumPage persona="investor" />} />

				{/* Neil Foster webinar registration */}
				<Route path={ROUTES.FOUNDER_SERIES_WEBINAR} element={<WebinarLanding />} />
				<Route path={ROUTES.INVESTMENT_READY} element={<InvestmentReadyCompanies />} />
				<Route path={ROUTES.GROWTH_READY} element={<GrowthReadyCompanies />} />
				<Route path={ROUTES.EXIT_READY} element={<ExitReadyCompanies />} />

				<Route path={ROUTES.LAWYERS} element={<Lawyers />} />
				<Route path={ROUTES.ACCOUNTANTS} element={<Accountants />} />

				<Route path={ROUTES.ANGEL_INVESTORS} element={<AngelInvestors />} />
				<Route path={ROUTES.ANGEL_NETWORKS} element={<AngelNetworks />} />
				<Route path={ROUTES.VENTURE_CAPITAL} element={<VentureCapitalFirms />} />
				<Route path={ROUTES.PRIVATE_EQUITY} element={<PrivateEquityFirms />} />

				{/* LOGGED IN */}
				<Route path={ROUTES.BILLINGS} element={<Billing />} />
				<Route path={ROUTES.BILLING_SUBSCRIPTION} element={<IndirectCompanyBillingPage />} />
				<Route path={ROUTES.BILLING} element={<InnerPricingPage />} />
				<Route path={ROUTES.PAYMENT_SUCCESS} element={<PaymentSuccess />} />
				<Route path={ROUTES.PAYMENT_CANCEL} element={<PaymentCancel />} />

				<Route path={ROUTES.COMPANY_OLD} element={<Company />} />
				<Route path={ROUTES.COMPANY} element={<CompanyNew optimized={true} />} />

				<Route path={ROUTES.DASHBOARD} element={<Dashboard />} />
				<Route path={ROUTES.ADVISOR} element={<Advisor />} />
				<Route path={ROUTES.INVESTOR} element={<Advisor />} />
				<Route path={ROUTES.COMPANY_SETTINGS} element={<CompanySettings />} />
				<Route path={ROUTES.ADVISORSETTINGS} element={<Settings />} />
				<Route path={ROUTES.INVESTORSETTINGS} element={<Settings />} />

				<Route path={ROUTES.EMAIL_CONFIRMATION} element={<ConfirmEmailChange />} />

				<Route path='/gDriveCallBack' element={<CompanyWrapper />} />
				<Route path='/dropBoxCallBack' element={<CompanyWrapper />} />
				<Route path='/sharePointCallBack' element={<CompanyWrapper />} />
				<Route path={ROUTES.GROUP} element={<Group />} />
				<Route path={ROUTES.PROFILE} element={<Profile />} />
				<Route path={ROUTES.SUPPORT} element={<Support />} />
				<Route path={ROUTES.REPORT} element={<Report />} />
				<Route path={ROUTES.EXPANSIONPACK} element={<ExpansionPack />} />
				<Route path={ROUTES.DIRECTORSPACK} element={<DirectorsPack />} />
				<Route path={ROUTES.INDUSTRYPACK} element={<IndustryPack />} />
				<Route path={ROUTES.ESGPACK} element={<ESGPack />} />
				<Route path={ROUTES.ExpansionReferencing} element={<ExpansionReferencing />} />

				{/* LOGGED IN AS ADMIN */}
				<Route path={ROUTES.ADMIN} element={<Admin />} />
				{/* <Route path={ROUTES.ADMIN_COMPANY_DETAILS} element={<AdminCompanyDetails />} /> */}

				{/* New Terms and Conditions Section */}
				<Route path={ROUTES.TERMS_CONDITION_COMPANY} element={<CompanyTerms />} />
				<Route path={ROUTES.TERMS_CONDITION_INDIVIDUALS_TERMS} element={<IndividualsTerms />} />
				<Route path={ROUTES.TERMS_CONDITION_ACCEPTABLE_USE} element={<AcceptableUse />} />

				{/* New Policies Section */}
				<Route path={ROUTES.POLICY_COOKIE} element={<CookiePolicy />} />
				<Route path={ROUTES.POLICY_DMCA} element={<DMCA />} />
				<Route path={ROUTES.POLICY_PRIVACY} element={< Privacy />} />
				<Route path={ROUTES.POLICY_DATA_ETHICS} element={<DataEthics />} />
				<Route path={ROUTES.POLICY_ALL_USE} element={<AllUse />} />

				{/* New About us */}
				<Route path={ROUTES.ABOUT_US} element={<AboutUs />} />
				{/* New Pricing Plan */}
				<Route path={ROUTES.PRICING_PLAN} element={<PricingPlans />} />
				{/* Contact us page */}
				<Route path={ROUTES.CONTACT_US} element={<ContactUs />} />
				{/* Partner program */}
				<Route path={ROUTES.PARTNER_PROGRAM} element={<LandingHomePartner />} />

				{/* Community */}
				<Route path={ROUTES.COMMUNITY} element={<LandingHomeCommunity />} />

				<Route path={ROUTES.TERMS} element={<Terms />} />
				<Route path={ROUTES.POLICIES} element={<Policies />} />
				<Route path="*" element={<NotFound />} />
			</Routes>
		</AnimatePresence >
	);
}
